/**
 * โหลดไฟล์ข้อมูลเกมและผูกชนิดให้เรียบร้อย
 * กฎข้อ 4 ของโปรเจกต์: อาชีพ สกิล ไอเทม มอนสเตอร์ เก็บเป็น JSON ไม่ฝังในโค้ด
 * ถ้าจะเพิ่มอาชีพหรือมอนสเตอร์ ให้แก้เฉพาะไฟล์ใน src/data
 */
import classesJson from "./data/classes.json" with { type: "json" };
import monstersJson from "./data/monsters.json" with { type: "json" };
import zonesJson from "./data/zones.json" with { type: "json" };
import itemsJson from "./data/items.json" with { type: "json" };
export const CLASS_LIST = classesJson;
export const MONSTER_LIST = monstersJson;
export const ZONE_LIST = zonesJson;
export const ITEM_LIST = itemsJson;
/** อาชีพทั้งหมด ค้นด้วย id */
export const CLASSES = Object.freeze(Object.fromEntries(CLASS_LIST.map((c) => [c.id, c])));
/** มอนสเตอร์ทั้งหมด ค้นด้วย id */
export const MONSTERS = Object.freeze(Object.fromEntries(MONSTER_LIST.map((m) => [m.id, m])));
/** โซนทั้งหมด ค้นด้วย id */
export const ZONES = Object.freeze(Object.fromEntries(ZONE_LIST.map((z) => [z.id, z])));
/** ไอเทมใช้แล้วหมดไป ค้นด้วย id */
export const ITEMS = Object.freeze(Object.fromEntries(ITEM_LIST.map((i) => [i.id, i])));
/** คืนอาชีพตาม id โยน error ถ้าไม่มี เพื่อจับ id ผิดตั้งแต่ตอน dev */
export function getClass(id) {
    const c = CLASSES[id];
    if (!c)
        throw new Error(`ไม่รู้จักอาชีพ "${id}" (มี: ${Object.keys(CLASSES).join(", ")})`);
    return c;
}
/** คืนมอนสเตอร์ตาม id โยน error ถ้าไม่มี */
export function getMonster(id) {
    const m = MONSTERS[id];
    if (!m)
        throw new Error(`ไม่รู้จักมอนสเตอร์ "${id}" (มี: ${Object.keys(MONSTERS).join(", ")})`);
    return m;
}
/** คืนโซนตาม id โยน error ถ้าไม่มี */
export function getZone(id) {
    const z = ZONES[id];
    if (!z)
        throw new Error(`ไม่รู้จักโซน "${id}" (มี: ${Object.keys(ZONES).join(", ")})`);
    return z;
}
/** คืนไอเทมตาม id โยน error ถ้าไม่มี */
export function getItem(id) {
    const i = ITEMS[id];
    if (!i)
        throw new Error(`ไม่รู้จักไอเทม "${id}" (มี: ${Object.keys(ITEMS).join(", ")})`);
    return i;
}
/** สกิลของอาชีพที่ปลดล็อกแล้วตาม Job Level */
export function unlockedSkills(cls, jobLevel) {
    return cls.skills.filter((s) => s.job <= jobLevel);
}
/** ตรวจสอบว่าเป็นอาชีพขั้นสูงหรือไม่ */
export function isAdvancedClass(id) {
    return CLASSES[id]?.tier === 2;
}
/** คืนอาชีพขั้นสูงของอาชีพเริ่มต้น (ถ้ามี) */
export function getAdvancedClassFor(baseClassId) {
    return CLASS_LIST.find((c) => c.tier === 2 && c.baseClass === baseClassId);
}
/** สกิลทั้งหมดของตัวละครรวมสกิลอาชีพขั้นต้น (ถ้าเป็นอาชีพขั้นสูง) */
export function getAllSkillsForClass(clsId) {
    const cls = CLASSES[clsId];
    if (!cls)
        return [];
    if (cls.tier === 2 && cls.baseClass) {
        const baseCls = CLASSES[cls.baseClass];
        return [...(baseCls?.skills ?? []), ...cls.skills];
    }
    return cls.skills;
}
/** หาสกิลด้วย id ภายในอาชีพ (รวมอาชีพขั้นต้นถ้าเป็นอาชีพขั้นสูง) */
export function findSkill(cls, skillId) {
    const found = cls.skills.find((s) => s.id === skillId);
    if (found)
        return found;
    if (cls.tier === 2 && cls.baseClass) {
        const baseCls = CLASSES[cls.baseClass];
        return baseCls?.skills.find((s) => s.id === skillId);
    }
    return undefined;
}
//# sourceMappingURL=data.js.map